import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';

export const DelayedNotificationsBar = withPageReadyAsync(() =>
  Promise.all([
    import(/* webpackMode: 'eager' */'@bingads-webui-campaign-react/notification-bar'),
    import(/* webpackMode: 'eager' */'@bingads-webui-campaign/notification-center'),
  ]).then(([
    { getNotificationsBar },
    {
      getStoreInstance,
      DisapprovedEntities,
      ImportStatus,
      NoEntityNotifications,
      PredefinedNotifications,
      UETNotifications,
      CCNotifications,
      ImportNotification,
      DraftStoreNotification,
      PmaxCampaignUpgradeNotification,
      LocationIntentUpdateNotifications,
      HotelCenterMigrationNotification,
      HotelCenterMigrationPhase2Notification,
      HotelCenterMigrationPhase3Notification,
      BroadOnlyNotification,
      GMCTokenExpiredNotification,
      DeprecateSyndicationSearchOnlyNotification,
    },
  ]) => {
    const getNotifications = context => [
      new PredefinedNotifications(context).getPredefinedAlerts(),
      new DisapprovedEntities(context).getDisapprovedEntityNotifications(),
      new ImportStatus(context).getImportStatusNotifications(),
      new NoEntityNotifications(context).getNoEligibleEntityNotifications(),
      new UETNotifications(context).getUETNotifications(),
      new CCNotifications(context).getCCNotifications(),
      new ImportNotification(context).getImportNotifications(),
      new DraftStoreNotification(context).DraftStoreNotifications(),
      new PmaxCampaignUpgradeNotification(context).getPmaxCampaignUpgradeNotifications(),
      new LocationIntentUpdateNotifications(context).getLocationIntentUpdateNotifications(),
      new HotelCenterMigrationPhase2Notification(context).getHotelCenterMigrationPhase2Notifications(),
      new HotelCenterMigrationPhase3Notification(context).getHotelCenterMigrationPhase3Notifications(),
      new HotelCenterMigrationNotification(context).getHotelCenterMigrationNotifications(),
      new BroadOnlyNotification(context).getBroadOnlyNotifications(),
      new GMCTokenExpiredNotification(context).getAlerts(),
      new DeprecateSyndicationSearchOnlyNotification(context).getDeprecateSyndicationSearchOnlyNotifications(),
    ];

    const store = getStoreInstance({
      getNotifications,
    });

    return {
      default: getNotificationsBar(store),
    };
  }), null);
